<template>
  <div>
    <div class="mt-15 container card_container">
      <div class="mb-5 titolo">
        <h3 class="text-white mt-5 text-center"><i class="fas fa-clipboard-list"></i> Pendenze Da Pagare</h3>
      </div>
      <b-container class="bv-example-row">
        <b-card bg-variant="light">
          <b-container class="bv-example-row pt-lg-6">
            <b-row>
              <b-col sm class="mb-7">
                <span class="text-primary">Codice fiscale</span><br />
                <span>{{ jsonData.assistito.codiceFiscale }}</span>
              </b-col>
              <b-col sm class="mb-7">
                <span class="text-primary">Assistito</span><br />
                <span>{{ jsonData.assistito.nome }} {{ jsonData.assistito.cognome }}</span>
              </b-col>
              <b-col sm class="mb-7">
                <span class="text-primary">Data di nascita</span><br />
                <span>{{ jsonData.assistito.dataNascita }}</span>
              </b-col>
            </b-row>
          </b-container>
        </b-card>
      </b-container>
    </div>
    <div v-if="items.length === 0">
      <div class="mt-5 container card_container mb-5">
        <b-card bg-variant="light" class="mb-5">
          <b-container class="bv-example-row pt-lg-6">
            <b-row class="text-center">
              <b-col sm class="mb-7">
                <strong><span style="margin-left: 10px" class="text-center">Non ci sono pendenze da pagare</span></strong>
              </b-col>
            </b-row>
          </b-container>
        </b-card>
      </div>
    </div>
    <div v-for="item in items" :key="item.idPrenotazione">
      <div class="mt-5 container card_container mb-5" v-if="jsonData.assistito.codiceFiscale">
        <b-card bg-variant="light" class="mb-5">
          <b-container class="bv-example-row pt-lg-6">
            <b-row>
              <b-col sm class="mb-7">
                <span class="text-primary">Struttura</span><br />
                <span>{{ item.appuntamenti[0].ambulatorio.descrizione }}</span>
              </b-col>
              <b-col sm class="mb-7">
                <span v-if="item.nre.match(/^\d{4}A\d{10}$/g) != null" class="text-primary">Codice impegnativa</span>
                <span v-else class="text-primary">Tipo Erogazione</span>
                <br />
                <span>{{ item.nre }}</span>
              </b-col>
            </b-row>
          </b-container>
        </b-card>
        <div>
          <h5 v-if="!item.enable" class="text-black">
            Stato pagamento:
            <b-badge v-if="statiPagamentoNonDisp.indexOf(item.stato) > -1" class="text-primary">{{ item.stato }} </b-badge>
            <b-badge v-else class="text-green">{{ item.stato }}</b-badge>
          </h5>
          <b-button v-else class="mx-2 mb-2 btn btn-primary" @click="onPaga(item)"><i class="far fa-credit-card fs-2x"></i> Paga </b-button>

          <b-button v-if="item.enable" class="mx-2 mb-2 btn btn-primary" @click="onScaricaAvviso(item)" v-b-modal.pdfmodel>
            <i class="fas fa-file-download"></i> PagoPA scarica avviso
          </b-button>
        </div>
        <div class="my-5">
          <datatable-lista-pendenze :appuntamenti="item.appuntamenti" :idModal="item.idPrenotazione"></datatable-lista-pendenze>
        </div>
        <b-card bg-variant="light" class="border-footer-card">
          <b-container class="bv-example-row">
            <b-row class="pt-lg-6">
              <b-col sm class="mb-7">
                <span class="text-primary">Tipo esenzione:</span>
                <span style="margin-left: 10px">N/D</span>
              </b-col>
              <b-col sm class="mb-7">
                <span class="text-primary">Importo:</span>
                <span style="margin-left: 10px">{{ item.importo }} €</span>
              </b-col>
            </b-row>
          </b-container>
        </b-card>
      </div>
    </div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" color="#274561" loader="dots" :height="120" :width="120"></loading>
    <pdf-viewer :pdf="jsonData.pdf" :title="title"></pdf-viewer>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import pdfViewer from "../pdfViewer/pdfViewer.vue";
import strutture from "../../classes/strutture";
import UtilityMixin from "../../utilities/utilityMixin";
import DatatableListaPendenze from "../datatable/datatableListaPendenze.vue";
import AuthService from "@/services/authService";
import EngiService from "@/services/engiService";

export default {
  mixins: [UtilityMixin],
  components: {
    Loading,
    pdfViewer,
    DatatableListaPendenze,
  },
  data() {
    return {
      pathResourceListaPagamenti: "/api/v2.0/appecupt/aslengi/listaPagamenti",
      pathResorce: "/api/v2.0/appecupt/auth/me",
      pathResourceInfoUtente: "/api/v2.0/appecupt/auth/prelevaAnagraficaUtente",
      pathResourcePaga: "/api/v2.0/appecupt/aslengi/purchase",
      pathResorceScaricaAvviso: "/api/v2.0/appecupt/aslengi/stampaAvvisoPagamento",
      contattiOptions: [{ value: "", contatto: "Seleziona Assistito" }],
      statiPagamentoNonDisp: ["In elaborazione", "Pagamento non disponibile"],
      jsonData: { assistito: {} },
      jsonCedolino: {
        nre: "",
        assistito: {
          nome: "",
          cognome: "",
          dataNascita: "",
          codiceFiscale: "",
        },
        appuntamenti: [
          {
            desPrestazione: "",
            dataAppuntamento: "",
            idPrenotazione: "",
            booleanNota: "",
            nota: "",
            reparto: { desReparto: "", ubicazioneReparto: "" },
          },
        ],
      },
      title: "Avviso Pagamento",
      infoUtente: null,
      token: null,
      tokenLogin: null,
      items: [],
      item: [],
      isLoading: false,
      fullPage: true,
      pdf: null,
      linkPrenota: "",
      listaStrutture: strutture,
      messaggioPrePagamento: JSON.parse(sessionStorage.getItem("messaggiUtente")).messaggioPrePagamento,
    };
  },
  mounted: async function () {
    let me = this;
    me.token = sessionStorage.getItem("tokenWSO2");
    me.tokenLogin = sessionStorage.getItem("loginData");
    await me.loadInfoUtente();
    await me.loadPendenze();
  },
  watch: {
    "jsonData.codiceFiscale": function () {
      let me = this;
      if (me.jsonData.codiceFiscale) {
        me.jsonCedolino.assistito = me.jsonData;
        me.loadPendenze();
      }
    },
  },
  methods: {
    async loadInfoUtente() {
      let me = this;
      try {
        const responseInfoUtente = await AuthService.anagraficaUtente(me.tokenLogin);
        me.jsonData.assistito = responseInfoUtente.data.data;
      } catch (error) {
        me.$bvModal
          .msgBoxOk(error, {
            title: "Errore",
            size: "md",
            okVariant: "outline-danger",
            headerClass: "vv-msg-header-danger",
            footerClass: "p-2 border-top-0",
            centered: true,
          })
          .then(() => {})
          .catch(() => {});
      }
    },
    async loadPendenze() {
      let me = this;
      me.isLoading = true;
      try {
        let paramentriListaPendenze = {
          codiceFiscale: me.jsonData.assistito.codiceFiscale,
        };
        const responseListaPendenze = await EngiService.listaPendenze(paramentriListaPendenze);
          if(responseListaPendenze.data.errore){
              me.$bvModal
                  .msgBoxOk(responseListaPendenze.data.errore, {
                      title: "Errore",
                      size: "md",
                      okVariant: "outline-danger",
                      headerClass: "vv-msg-header-danger",
                      footerClass: "p-2 border-top-0",
                      centered: true,
                  })
                  .then(() => {})
                  .catch(() => {});
          }else{
              me.items = responseListaPendenze.data.data;
              me.items.forEach((element) => {
                  me.item.push(element);
              });
          }

        me.isLoading = false;
      } catch (e) {
        me.isLoading = false;
        me.$bvModal
          .msgBoxOk(e, {
            title: "Errore",
            size: "md",
            okVariant: "outline-danger",
            headerClass: "vv-msg-header-danger",
            footerClass: "p-2 border-top-0",
            centered: true,
          })
          .then(() => {})
          .catch(() => {});
      }
    },
    onPaga(item) {
      let me = this;
      me.$bvModal
        .msgBoxConfirm(me.messaggioPrePagamento, {
          title: "Conferma Pagamento",
          footerClass: "p-2",
          centered: true,
          cancelTitle: "Chiudi",
          okTitle: "Conferma",
        })
        .then(async (response) => {
          if (response) {
            me.isLoading = true;
            try {
              const parametriPagamento = {
                idTransazione: item.idTransazione,
              };
              const responsePaga = await EngiService.pagamento(parametriPagamento);
              if (responsePaga.data.stato === 200) {
                me.isLoading = false;
                location.href = responsePaga.data.data;
              } else {
                me.$bvModal
                  .msgBoxOk(response.data.errore, {
                    title: "Errore",
                    size: "md",
                    okVariant: "outline-success",
                    headerClass: "vv-msg-header-success",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                  })
                  .then(() => {
                    me.isLoading = false;
                  })
                  .catch(() => {});
              }
            } catch (e) {
              me.isLoading = false;
              me.$bvModal
                .msgBoxOk(e, {
                  title: "Errore",
                  size: "md",
                  okVariant: "outline-danger",
                  headerClass: "vv-msg-header-danger",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                })
                .then(() => {})
                .catch(() => {});
            }
          }
          me.isLoading = false;
        })
        .catch((error) => {
          me.isLoading = false;
          me.$bvModal
            .msgBoxOk(error, {
              title: "Errore",
              size: "md",
              okVariant: "outline-danger",
              headerClass: "vv-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then(() => {})
            .catch(() => {});
        });
    },
    async onScaricaAvviso(item) {
      let me = this;
      me.isLoading = true;
      try {
        const parametriScaricaAvviso = {
          idTransazione: item.idTransazione,
        };
        const responseScaricaAvviso = await EngiService.stampaAvvisoPagamento(parametriScaricaAvviso);
        me.jsonData.pdf = responseScaricaAvviso.data.data;
        me.isLoading = false;
      } catch (e) {
        me.isLoading = false;
        console.log(e);
      }
    },
  },
};
</script>
